// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';

export const updatePinCrossReferenceCriteria = (attribute, value) => ({
    attribute,
    type: actions.UPDATE_PIN_CROSS_REFERENCE_CRITERIA,
    value
});



// WEBPACK FOOTER //
// ./src/reports/pin-cross-reference/action-creators/criteria.js